import Spine from "../spine";
import ExSection from "./section";
import ExEpubCFI from "./epubcfi";
import Url from "../utils/url";
import {replaceBase, replaceCanonical, replaceMeta} from "../utils/replacements";

import Hook from "./utils/hook";

class ExSpine extends Spine{
	constructor(book){
		super();

		//置換ExEpubCFI
		this.epubcfi = new ExEpubCFI();

		//加入 spineByLinearYesIndex 屬性 ( 只存放 linear = 'yes' 的 index )
		this.spineByLinearYesIndex = [];

		//加入spineByFilename
        this.spineByFilename = {};
		
		//加入book
		this.book = book;

		//取代 Hook
		this.hooks = {};
		this.hooks.serialize = new Hook();
		this.hooks.content = new Hook();

		// Register replacements
		this.hooks.content.register(replaceBase);
		this.hooks.content.register(replaceCanonical);
		this.hooks.content.register(replaceMeta);
	}

	getSpineIndexByPage(pageNum){
		return this.items[pageNum-1].index;
	}

	/**
	 * Unpack items from a opf into spine items
	 * @param  {Packaging} _package
	 * @param  {method} resolver URL resolver
	 * @param  {method} canonical Resolve canonical url
	 */
	 unpack(_package, resolver, canonical) {

		this.items = _package.spine;
		this.manifest = _package.manifest;
		this.spineNodeIndex = _package.spineNodeIndex;
		this.baseUrl = _package.baseUrl || _package.basePath || "";
		this.length = this.items.length;

		this.items.forEach( (item, index) => {
			var manifestItem = this.manifest[item.idref];
			var spineItem;

			item.index = index;
			item.cfiBase = this.epubcfi.generateChapterComponent(this.spineNodeIndex, item.index, item.idref);

			if (item.href) {
				item.url = resolver(item.href, true);
				item.canonical = canonical(item.href);
			}

			if(manifestItem) {
				item.href = manifestItem.href;
				//使用 manifestItem 中修正後url置換
				//item.url = (manifestItem.url && manifestItem.url !== "") ? manifestItem.url : resolver(item.href, true);
				
				//使用 manifestItem 中加入的token
				item.token = manifestItem.token || "";

				item.url =  resolver(item.href, true);
				item.canonical = canonical(item.href);

				if(manifestItem.properties.length){
					item.properties.push.apply(item.properties, manifestItem.properties);
				}
			}

			if (item.linear === "yes") {
				item.prev = function() {
					let prevIndex = item.index;
					while (prevIndex > 0) {
						let prev = this.get(prevIndex-1);
						if (prev && prev.linear) {
							return prev;
						}
						prevIndex -= 1;
					}
					return;
				}.bind(this);
				item.next = function() {
					let nextIndex = item.index;
					while (nextIndex < this.spineItems.length-1) {
						let next = this.get(nextIndex+1);
						if (next && next.linear) {
							return next;
						}
						nextIndex += 1;
					}
					return;
				}.bind(this);
			} else {
				item.prev = function() {
					return;
				}
				item.next = function() {
					return;
				}
			}

			spineItem = new ExSection(item, this.hooks, this.book);

			this.append(spineItem);


		});

		//添加固定版書籍頁面位置屬性
		if(this.book.package.metadata.layout === "pre-paginated" || this.book.displayOptions.fixedLayout === "true"){
			let prevSettingProperties, nextSettingProperties, nextItem, prevItem;
			//[章節屬性資訊]
			let totalSpine = 0, hadPropSpine = 0, noPropSpine = 0;
			this.spineByLinearYesIndex.forEach( (spineIndex, index) => {
				let item = this.get(spineIndex);
				//測試
				//[保留原值]
				item.init_properties = [...item.properties];
				totalSpine += 1;
				if(item.init_properties.length){
					hadPropSpine += 1;
				}else{
					noPropSpine += 1;
				}
				
				if((!(item.properties.includes("page-spread-right") || item.properties.includes("rendition:page-spread-right")) && !(item.properties.includes("page-spread-left") || item.properties.includes("rendition:page-spread-left"))) && ( index === 0 || index === this.spineByLinearYesIndex.length -1)){
					//沒有左右頁屬性的頁首和頁尾
					if(!(item.properties.includes("page-spread-center") || item.properties.includes("rendition:page-spread-center"))){
						//沒有置中屬性的頁首和頁尾
						prevItem = (index !== 0) ? this.get(this.spineByLinearYesIndex[index-1]) : null;
						nextItem = (index !== this.spineByLinearYesIndex.length -1) ? this.get(this.spineByLinearYesIndex[index+1]) : null;
						if(prevItem){
							//頁尾
							if(this.book.package.metadata.direction === "ltr" && (prevItem.properties.includes("page-spread-left") || prevItem.properties.includes("rendition:page-spread-left"))){
								item.properties.push("page-spread-right");
								prevSettingProperties = "page-spread-right";
							}else if(this.book.package.metadata.direction === "rtl" && (prevItem.properties.includes("page-spread-right") || prevItem.properties.includes("rendition:page-spread-right"))){
								item.properties.push("page-spread-left");
								prevSettingProperties = "page-spread-left";
							}else{
								item.properties.push("page-spread-center");
								prevSettingProperties = "page-spread-center";
							}
							//修補頁尾前一頁屬性
							if(index === this.spineByLinearYesIndex.length -1){
								if(prevSettingProperties !== "page-spread-center"){
									prevItem = this.get(this.spineByLinearYesIndex[index-1]);
									if(this.book.package.metadata.direction === "ltr" && prevSettingProperties === "page-spread-left"){
										prevItem.properties.push("page-spread-center-left");
									}else if(this.book.package.metadata.direction === "rtl" && prevSettingProperties === "page-spread-right"){
										prevItem.properties.push("page-spread-center-right");
									}
								}
							}
						}else if(nextItem){
							//頁首
							let theClosestPropInfo = this.getTheClosestPropInfo(index);

							if(theClosestPropInfo.isAllBookNoProp || theClosestPropInfo.noPropNum === 1){
								//全書無屬性或謹首頁無屬性
								if(spineIndex === 0){
									//以首頁置中為主邏輯
									item.properties.push("page-spread-center");
									prevSettingProperties = "page-spread-center";
								}else{
									//以翻書方向順編邏輯
									if(this.book.package.metadata.direction === "ltr"){
										item.properties.push("page-spread-left");
										prevSettingProperties = "page-spread-left";
									}else{
										item.properties.push("page-spread-right");
										prevSettingProperties = "page-spread-right";
									}
								}
							}else{
								if(this.book.package.metadata.direction === "ltr" && (nextItem.properties.includes("page-spread-right") || nextItem.properties.includes("rendition:page-spread-right"))){
									item.properties.push("page-spread-left");
									prevSettingProperties = "page-spread-left";
								}else if(this.book.package.metadata.direction === "rtl" && (nextItem.properties.includes("page-spread-left") || nextItem.properties.includes("rendition:page-spread-left"))){
									item.properties.push("page-spread-right");
									prevSettingProperties = "page-spread-right";
								}else{
									if(spineIndex === 0){
										//以首頁置中為主邏輯
										item.properties.push("page-spread-center");
										prevSettingProperties = "page-spread-center";
									}else{
										//以翻書方向順編邏輯
										if(this.book.package.metadata.direction === "ltr"){
											item.properties.push("page-spread-left");
											prevSettingProperties = "page-spread-left";
										}else{
											item.properties.push("page-spread-right");
											prevSettingProperties = "page-spread-right";
										}
									}
								}
							}
						}else{
							//只有一頁
							item.properties.push("page-spread-center");
							prevSettingProperties = "page-spread-center";
						}
					}else{
						//修補頁尾前一頁屬性
						if(index === this.spineByLinearYesIndex.length -1){
							if(prevSettingProperties !== "page-spread-center"){
								prevItem = this.get(this.spineByLinearYesIndex[index-1]);
								if(this.book.package.metadata.direction === "ltr" && prevSettingProperties === "page-spread-left"){
									prevItem.properties.push("page-spread-center-left");
								}else if(this.book.package.metadata.direction === "rtl" && prevSettingProperties === "page-spread-right"){
									prevItem.properties.push("page-spread-center-right");
								}
							}
						}
					}
				}else{
					if(prevSettingProperties === "page-spread-center" || typeof prevSettingProperties === "undefined"){
						nextSettingProperties = (this.book.package.metadata.direction === "ltr") ? "page-spread-left":"page-spread-right";
					}else{
						nextSettingProperties = (prevSettingProperties === "page-spread-right") ? "page-spread-left":"page-spread-right";
					}
					if(!(item.properties.includes("page-spread-center") || item.properties.includes("rendition:page-spread-center"))){
						if(nextSettingProperties === "page-spread-left"){
							if((item.properties.includes("page-spread-right") || item.properties.includes("rendition:page-spread-right"))){
								if(this.book.package.metadata.direction === "rtl"){
									prevItem = this.get(this.spineByLinearYesIndex[index-1]);
									nextItem = this.get(this.spineByLinearYesIndex[index+1]);
									if(nextItem && nextItem.properties.includes("page-spread-left") || nextItem.properties.includes("rendition:page-spread-left")){
										prevItem.properties.push("page-spread-center-right");
										prevSettingProperties = "page-spread-right";
									}else{
										item.properties.push("page-spread-center-right");
										prevSettingProperties = "page-spread-center";
									}
								}else{
									item.properties.push("page-spread-center-right");
									prevSettingProperties = "page-spread-center";
								}
							}else{
								if(!(item.properties.includes("page-spread-left") || item.properties.includes("rendition:page-spread-left"))){
									item.properties.push("page-spread-left");
									prevSettingProperties = "page-spread-left";
								}else if(this.book.package.metadata.direction === "ltr" && index === this.spineByLinearYesIndex.length -1){
									//單頁頁尾
									item.properties.push("page-spread-center-left");
									prevSettingProperties = "page-spread-center";
								}else{
									prevSettingProperties = "page-spread-left";
								}
								
							}
						}else{
							if((item.properties.includes("page-spread-left") || item.properties.includes("rendition:page-spread-left"))){
								if(this.book.package.metadata.direction === "ltr"){
									prevItem = this.get(this.spineByLinearYesIndex[index-1]);
									nextItem = this.get(this.spineByLinearYesIndex[index+1]);
									if(nextItem && nextItem.properties.includes("page-spread-right") || nextItem.properties.includes("rendition:page-spread-right")){
										prevItem.properties.push("page-spread-center-left");
										prevSettingProperties = "page-spread-left";
									}else{
										item.properties.push("page-spread-center-left");
										prevSettingProperties = "page-spread-center";
									}
								}else{
									item.properties.push("page-spread-center-left");
									prevSettingProperties = "page-spread-center";
								}
							}else{
								if(!(item.properties.includes("page-spread-right") || item.properties.includes("rendition:page-spread-right"))){
									item.properties.push("page-spread-right");
									prevSettingProperties = "page-spread-right";
								}else if(this.book.package.metadata.direction === "rtl" && index === this.spineByLinearYesIndex.length -1){
									//單頁頁尾
									item.properties.push("page-spread-center-right");
									prevSettingProperties = "page-spread-center";
								}else{
									prevSettingProperties = "page-spread-right";
								}
							}
						}
					}else{
						prevItem = this.get(this.spineByLinearYesIndex[index-1]);
						if(this.book.package.metadata.direction === "rtl" && (prevItem.properties.includes("page-spread-right") || prevItem.properties.includes("rendition:page-spread-right")) ){
							prevItem.properties.push("page-spread-center-right");
						}else if(this.book.package.metadata.direction === "ltr" && (prevItem.properties.includes("page-spread-left") || prevItem.properties.includes("rendition:page-spread-left"))){
							prevItem.properties.push("page-spread-center-left");
						}
						prevSettingProperties = "page-spread-center";
					}
				}
			});
			//測試
			//[章節屬性資訊]
			//console.log(`Spine Total:${totalSpine}, With Properties Num:${hadPropSpine}, No Properties Num:${noPropSpine}`);
		}

		this.loaded = true;
	}

	getTheClosestPropInfo(index){
		let nextIndex = index + 1;
		let noPropNum = 1;
		let theClosestPropItem = null;
		let isAllBookNoProp = false;
		let spineIndex = null;
		while (nextIndex < this.spineByLinearYesIndex.length) {
			spineIndex = this.spineByLinearYesIndex[nextIndex];
			let item = this.get(spineIndex);
			if (item.properties.length) {
			  theClosestPropItem = item;
			  break;
			}else{
				noPropNum += 1;
			}
			nextIndex += 1;
		}
		if(noPropNum === this.spineByLinearYesIndex.length){
			isAllBookNoProp = true;
		}
		let info = {
			"isAllBookNoProp":isAllBookNoProp,
			"index":(theClosestPropItem) ? nextIndex : null,
			"spineIndex":(theClosestPropItem) ? spineIndex : null,
			"noPropNum":noPropNum,
			"theClosestPropItem":theClosestPropItem
		};
		return info;
	}

    /**
	 * Get an item from the spine
	 * @param  {string|number} [target]
	 * @return {Section} section
	 * @example spine.get();
	 * @example spine.get(1);
	 * @example spine.get("chap1.html");
	 * @example spine.get("#id1234");
	 */
	get(target) {
		var index = 0;
		if (typeof target === "undefined") {
			while (index < this.spineItems.length) {
				let next = this.spineItems[index];
				if (next && next.linear) {
					break;
				}
				index += 1;
			}
		} else if(this.epubcfi.isCpctString(target)){
			let cpctIndex = this.epubcfi.getSpineIndexFromCpct(target);
			if(cpctIndex < this.spineItems.length){
				index = cpctIndex;
			}
		} else if(this.epubcfi.isCfiString(target)) {
			let cfi = new ExEpubCFI(target);
			if(cfi.spinePos < this.spineItems.length){
				index = cfi.spinePos;
			}
		} else if(typeof target === "number" || isNaN(target) === false){
			index = target;
		} else if(typeof target === "string" && target.indexOf("#") === 0) {
			index = this.spineById[target.substring(1)];
		} else if(typeof target === "string") {
			index = this.book.hrefToSpineIndexList[target];
			if(typeof index !== 'number'){
				
				//先以toc尋找
				let tocItem = this.book.navigation.get(target);
				if(tocItem){
					let targetByToc = tocItem.displayHref || tocItem.href;
					if(this.spineByHref[targetByToc] >= 0){
						index = this.spineByHref[targetByToc];
					}else if(this.spineByHref[encodeURI(targetByToc)] >= 0){
						index = this.spineByHref[encodeURI(targetByToc)];
					}else if(this.spineByFilename[targetByToc] >= 0){
						index = this.spineByFilename[targetByToc];
					}
				}

				//若沒有再用spine方式尋找
				if(!index){
					// Remove fragments
					target = target.split("#")[0];
					//加入用filename取得toc的方法
					//修正index為0會取不到spine的問題
					if(this.spineByHref[target] >= 0){
						index = this.spineByHref[target];
					}else if(this.spineByHref[encodeURI(target)] >= 0){
						index = this.spineByHref[encodeURI(target)];
					}else if(this.spineByFilename[target] >= 0){
						index = this.spineByFilename[target];
					}
				}

			}
		}

		return this.spineItems[index] || null;
	}

	/**
	 * Append a Section to the Spine
	 * @private
	 * @param  {Section} section
	 */
	 append(section) {
		var index = this.spineItems.length;
		section.index = index;

		this.spineItems.push(section);

		// Encode and Decode href lookups
		// see pr for details: https://github.com/futurepress/epub.js/pull/358
		this.spineByHref[decodeURI(section.href)] = index;
		this.spineByHref[encodeURI(section.href)] = index;
		this.spineByHref[section.href] = index;

		this.spineById[section.idref] = index;

		//加入spineByFilename
		let url = new Url(section.href);
		section.filename = url.filename;
		this.spineByFilename[url.filename] = index;

		//加入 index 到 spineByLinearYesIndex
		if(section.linear){
			this.spineByLinearYesIndex.push(index);
			var LinearYesIndex = this.spineByLinearYesIndex.length;
		}

		return index;
	}

	destroy() {
		super.destroy();
		this.book = undefined;
	}
}

export default ExSpine;